import React, { Component } from 'react';
import '../App.css';
import ReactJson from 'react-json-view'
import { getJson } from '../helpers/RequestsHelper';

export default class JsonViewComponent extends Component {

    state = {
        loading: true
    }

    constructor(props) {
        super(props)
        this.loadJson = this.loadJson.bind(this)
    }

    componentDidMount() {
        this.loadJson()
    }

    async loadJson() {
        if (this.props.json) {
            this.setState(({ json: this.props.json, loading: false }))
        } else if (this.props.path) {
            const json = await getJson(process.env.REACT_APP_SERVER_BASE_URL + this.props.path)
            this.props.onLoaded(json)
            this.setState(({ json: json, loading: false }))
        }
    }

    render() {
        if (this.state.loading) {
            return (<div>"Loading..."</div>)
        }
        
        return (
            <div className="json-view">
                <ReactJson src={this.state.json} /><br /> <br />
            </div>
        )
    }
}
